import React from 'react';
import backgroundImg from 'components/login/illustrations/background.png';
import directoryImg from './illustrations/partner-directory.webp';

export default function SignupIllustration() {
  return (
    <div
      className="auth-split_illustration"
      style={{ backgroundImage: `url(${backgroundImg})` }}
    >
      <div className="auth-split_illustration-content">
        <h2>Become a partner</h2>
        <p>
          Get paid for your work, get discovered, and turn
          <br />
          your apps into a business.
        </p>
      </div>
      <img
        className="signup-illustration_directory"
        src={directoryImg}
        alt=""
      />
    </div>
  );
}
